import { List, ListItem, ListItemText, Divider } from '@mui/material';
import { FC, Fragment, useEffect, useState } from 'react';
import { Accordion, Link } from '../../../../components';
import { formatShortFriendlyDateWithTime } from '../../../../helpers';
import { ITopLevelJobPunchlist, ITopLevelPunchlist } from '../../../../models';

interface IJobAccordion {
  isAllAccodionsExpanded?: boolean;
  job: ITopLevelJobPunchlist;
}

export const JobAccordion: FC<IJobAccordion> = ({ isAllAccodionsExpanded, job }) => {
  const [isExpanded, setExpanded] = useState<boolean>(isAllAccodionsExpanded ?? false);
  useEffect(() => {
    setExpanded(isAllAccodionsExpanded);
  }, [isAllAccodionsExpanded]);
  return (
    <Accordion
      showShading={false}
      isExpanded={isExpanded}
      onChange={(_, expanded) => {
        setExpanded(expanded);
      }}
      title={`Job: ${job.sageJobId}`}
    >
      <List disablePadding>
        {job?.punchLists?.map((punchlist: ITopLevelPunchlist, index) => {
          return (
            <Fragment key={`${index}`}>
              <ListItem>
                <ListItemText
                  primary={
                    <Link to={`/production/punchlists/${punchlist.punchListId}`}>
                      {punchlist.punchListName}
                    </Link>
                  }
                  secondary={`Last Updated: ${formatShortFriendlyDateWithTime(
                    punchlist.lastUpdated
                  )}`}
                />
              </ListItem>
              {job?.punchLists?.length >= 1 && index !== job?.punchLists?.length - 1 && <Divider />}
            </Fragment>
          );
        })}
      </List>
    </Accordion>
  );
};
